module.exports = __webpack_public_path__ + "media/images/lp_flow-3-911bbf593355f21e5eae42c35db38f43.webp";